<template>
<v-card class="elevation-2">
  <v-card-media class="secondary--text text-xs-left" height="175px" src="/static/img/Rophem-LMS-Background.jpg">
    <v-layout column>
      <v-spacer></v-spacer>
      <div class="title-bg px-3 pt-2 text-xs-center">
        <div class="headline half-spaced"><b>{{courseData.name}}</b></div>
        <div v-if="courseData.type == 'Online'" class="subheading caps half-spaced"><b>online</b></div>
        <div v-else class="subheading">
          <span v-for="date, i in courseData.dates" :key="i"><b>{{date}}</b>{{i < courseData.dates.length - 1 ? ', ' : ''}}</span>
        </div>
      </div>
    </v-layout>
  </v-card-media>
  <v-layout row wrap justify-center>
    <v-flex v-if="loading || changing" xs12>
      <v-progress-circular color="primary" size="34" indeterminate></v-progress-circular>
    </v-flex>
    <v-flex v-else class="pt-2 pb-1" xs12>
      <div class="status-text caps spaced">
        <b>
          <span v-if="courseObtained()" class="primary--text">Purchased</span>
          <span v-else-if="courseData.type == 'Live'">
            <span v-if="open">
              <span class="error--text" v-if="parseInt(courseData.maxStudents) - parseInt(studentCount) <= 3">{{(parseInt(courseData.maxStudents) - parseInt(studentCount)) + ' seats left'}}</span>
              <span v-else class="success--text">Open</span>
            </span>
            <span v-else class="error--text">Closed</span>
          </span>
          <span v-else class="success--text">Open</span>
        </b>
      </div>
    </v-flex>
    <v-flex class="px-1" xs12>
      <div class="caption caps half-spaced"><b>Online Access Time</b></div>
      <v-btn 
        v-for="p in courseOptions"
        @click.native="getCourseData(p)"
        class="ma-0"
        :color="courseData.key == p.key ? 'primary' : 'grey'"
        :key="p.key"
        flat>
        <v-icon class="mr-1">{{courseData.key == p.key ? 'check_box' : 'check_box_outline_blank'}}</v-icon>
        <span><b>{{p.onlineDays + ' Days'}}</b></span>
      </v-btn>
    </v-flex>
    <v-flex class="text-xs-left" xs6>
      <v-btn 
        @click.native="register" 
        class="subheading half-spaced" 
        color="success"
        :loading="registering"
        :disabled="registering || !open || courseObtained() || changing"
        flat
      ><b>Register - ${{courseData.price}}</b></v-btn>
    </v-flex>
    <v-flex class="text-xs-right" xs6>
      <v-btn @click.native="expanded = !expanded" color="primary" flat :icon="expanded" :ripple="false">
        <v-icon v-if="expanded">expand_less</v-icon>
        <span class="half-spaced" v-else><b>Details</b></span>
      </v-btn>
    </v-flex>
  </v-layout>

  <v-slide-y-transition>
    <v-layout v-show="expanded" class="text-xs-left px-3" row wrap justify-center>
      <v-flex class="pb-1" xs4>
        <v-divider></v-divider>
      </v-flex>
      <v-flex v-if="courseData.type == 'Live'" class="py-2 subheading" xs12>
        <div class="caps half-spaced"><b>course details</b></div>
        <div><b>Dates:</b> <span v-for="date, i in courseData.dates" :key="date">{{date}}{{i < courseData.dates.length - 1 ? ', ' : ''}}</span></div>
        <div><b>Time:</b> {{courseData.startTime + ' to ' + courseData.endTime}}</div>
        <div><b>Location:</b> {{courseData.location}}</div>
      </v-flex>
      <v-flex v-if="courseContent.length > 0" class="py-2 subheading" xs12>
        <div class="caps half-spaced"><b>course content</b></div>
        <div v-for="content in courseContent" class="-text-xs-left">
          <div class="half-spaced"><b><u>{{content.name}}</u></b></div>
          <div class="quill-card" v-html="content.descText"></div>
        </div>
      </v-flex>
    </v-layout>
  </v-slide-y-transition>
</v-card>
</template>

<script>
import {coursesEvent} from '../../../main'
export default {
  props: ['now', 'courses'],
  data: () => ({
    loading: false,
    changing: false,
    expanded: false,
    courseData: {},
    choice: '',
    registering: false,
    popup: {
      show: false,
      type: ''
    }
  }),
  computed: {
    progress () {
      return this.$store.getters.progress
    },
    courseOptions () {
      this.courseData = this.courses[0]
      return this.courses
    },
    courseContent () {
      const contents = []
      if (this.courseData.content) {
        for (let key of this.courseData.content) {
          contents.push(this.$store.getters.contentByKey(key))
        }
      }
      return contents
    },
    open () {
      let liveOpen = false
      if (this.courseData.type === 'Live') {
        liveOpen = this.courseData.type === 'Live' && this.courseData.maxStudents > this.studentCount
        liveOpen = liveOpen && this.now < new Date(this.courseData.dates[0]).valueOf()
        return liveOpen
      } else return true
    },
    studentCount () {
      let count = 0
      const linked = this.$store.getters.linkedCourses(this.courseData.key)
      const linkedStudents = []
      for (let c of linked) {
        if (c.students) {
          for (let s of c.students) {
            if (!linkedStudents.includes(s)) linkedStudents.push(s)
          }
        }
      }
      for (let uid of linkedStudents) {
        if (this.hasProgress(uid)) count += 1
      }
      return count
    }
  },
  methods: {
    getCourseData (course) {
      this.changing = true
      setTimeout(() => {
        this.courseData = course
        this.changing = false
      }, 250)
    },
    register () {
      this.registering = true
      setTimeout(() => {
        coursesEvent.$emit('registerPopup', this.courseData.key)
        this.registering = false
      }, 250)
    },
    courseObtained () {
      let user = this.$store.getters.user
      if (user) {
        return this.hasProgress(user.uid)
      }
      return false
    },
    hasProgress (uid) {
      const linkedKeys = []
      for (let c of this.$store.getters.linkedCourses(this.courses[0].key)) {
        linkedKeys.push(c.key)
      }
      let rightProgress = false
      let notEnded = false
      for (let p of this.progress) {
        rightProgress = (p.studentId === uid) && (linkedKeys.includes(p.courseKey))
        notEnded = (p.endTime === 0) || (this.now < p.endTime)
        if (rightProgress && notEnded) return true
      }
      return false
    }
  }
}
</script>

<style>
.title-bg {
  background: linear-gradient(to top, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
}
.status-text {
  font-size: 120%;
}
.quill-card h1,
.quill-card h2,
.quill-card h3 {
  margin-bottom: 5px;
}
.quill-card p {
  margin: 0 0 5px 0;
  line-height: 120%;
}
.quill-card li {
  margin: 0 0 5px 0;
  line-height: 120%;
}
.quill-card ol, .quill-card ul {
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/site/courses/CourseCard.vue